<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">{{ $t('reExamAndReLearn.pageTitle') }}</h1>
            <ts-breadcrumb :items="[
                { text: $t('toHomePage'), href: '/' },
                {
                    text: $t('reExamAndReLearn.pageTitle'),
                    active: true
                }
            ]" />
        </div>
        <div class="row">
            <div class="col-md-4">
                <ts-card>
                    <ts-card-wrapper>
                        <ts-loading-banner :loading="loading">
                            <form>
                                <fieldset>
                                    <legend>{{ $t('reExamAndReLearn.criteria') }}</legend>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('reExamAndReLearn.branchName')
                                                }}</label>
                                            <a-select style="width: 100%" v-model.number="model.branch_id"
                                                :options="branches"></a-select>
                                            <div class="validate" v-if="errors.has('branch_id')">
                                                {{ errors.first('branch_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('reExamAndReLearn.acYear')
                                            }}</label>
                                            <a-select style="width: 100%" v-model.number="model.ac_year_id"
                                                :options="ac_year_list" @change="acYearChange"></a-select>
                                            <div class="validate" v-if="errors.has('ac_year_id')">
                                                {{ errors.first('ac_year_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('reExamAndReLearn.subProgram')
                                            }}</label>
                                            <a-select style="width: 100%" v-model.number="model.acps_id"
                                                :options="sub_programs" :show-search="true" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " @change="onSubChange" :disabled="!model.ac_year_id"></a-select>
                                            <div class="validate" v-if="errors.has('acps_id')">
                                                {{ errors.first('acps_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label>{{ $t('reExamAndReLearn.Degree') }}</label>
                                            <a-select style="width: 100%" v-model="model.level_id" mode="multiple"
                                                :options="levels" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    "></a-select>
                                            <div class="validate" v-if="errors.has('level_id')">
                                                {{ errors.first('level_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{
                                                $t('reExamAndReLearn.acTerm')
                                                }}</label>
                                            <a-select style="width: 100%" v-model.number="model.ac_term_id"
                                                :options="ac_terms" :show-search="true" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " @change="acTermChange"></a-select>
                                            <div class="validate" v-if="errors.has('ac_term_id')">
                                                {{ errors.first('ac_term_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label>{{ $t('reExamAndReLearn.classOperation') }}</label>
                                            <a-select style="width: 100%" v-model="model.class_id"
                                                :options="class_options" :show-search="true" mode="multiple"
                                                placeholder="All" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    "></a-select>
                                            <div class="validate" v-if="errors.has('class_id')">
                                                {{ errors.first('class_id') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ts-button class="btn-block" outline color="success" :waiting="exporting"
                                                @click.prevent="exportExcel">{{ $t('excel')
                                                }}</ts-button>

                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </ts-loading-banner>
                    </ts-card-wrapper>
                </ts-card>
            </div>
            <div class="col-md-8">
                <ts-card>
                    <ts-card-wrapper>
                        <form>
                            <fieldset>
                                <legend>{{ $t('finalResult.preview') }}</legend>
                                <ts-preview-pdf v-model="waiting" :src="src" />
                            </fieldset>
                        </form>
                    </ts-card-wrapper>
                </ts-card>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
    name: 'reExamAndReLearn',
    data() {
        return {
            loading: false,
            errors: new Errors(),
            waiting: false,
            exporting: false,
            src: '',
            branches: [],
            ac_year_list: [],
            sub_programs: [],
            ac_terms: [],
            levels: [],
            class_options: [],
            model: {
                branch_id: null,
                ac_year_id: null,
                acps_id: null,
                ac_term_id: null,
                level_id: [],
                class_id: []
            }
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        ...mapActions('reportAcademic', [
            'getBranch',
            'getYear',
            'getSubProgram',
            'getTerm',
            'getLevel',
            'getClass',
            'reExamExportExcel']),
        ...mapActions('generateTotalScore', ['getStudentScoringEntry']),

        async fetchData() {
            this.loading = true

            await this.getBranch().then(response => {
                this.branches = response.data.map(el => ({
                    value: el.branch_id,
                    label: el.branch_name_en
                }))
                this.model.branch_id = this.$store.state.authUser.default_branch_id
            })
            await this.getYear()
                .then(response => {
                    this.ac_year_list = response.data.map(el => ({
                        value: el.ac_year_id,
                        label: el.ac_year
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
            await this.getSubProgram().then(response => {
                this.sub_programs = response.data.map(el => ({
                    value: el.acps_id,
                    label: el.acps_name_foreign
                }))
            })
        },
        acYearChange() {
            this.model.acps_id = null
            this.model.ac_term_id = null
            this.model.level_id = []
            this.model.class_id = []
        },
        async onSubChange(acps_id) {
            this.model.ac_term_id = null
            this.model.level_id = []
            this.model.class_id = []
            this.levels = []
            this.loading = true
            await this.getTerm({
                filter: {
                    acps_id: acps_id,
                    ac_status_id: '1,2',
                    ac_year_id: this.model.ac_year_id
                }
            })
                .then(response => {
                    this.ac_terms = response.data.map(el => ({
                        value: el.ac_term_id,
                        label:
                            el.term_name +
                            (el.ac_status_id == 1
                                ? ' ( Current ) '
                                : el.ac_status_id == 2
                                    ? ' ( History ) '
                                    : null)
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })

            await this.getLevel({
                filter: {
                    acps_id: acps_id
                }
            })
                .then(response => {
                    this.levels = response.data.map(el => ({
                        value: el.level_id,
                        label: el.level_name_foreign
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        acTermChange(ac_term_id) {
            this.loading = true
            this.getClass({
                filter: {
                    ac_term_id: ac_term_id
                }
            })
                .then(response => {
                    this.class_options = response.data.map(el => ({
                        value: el.class_id,
                        label: el.class_name
                    }))
                    this.fetchStudentScoringEntry()
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        fetchStudentScoringEntry() {
            this.loading = true
            this.model.scoring_cycle_id = null
            this.model.cycle_value = null

            this.getStudentScoringEntry({ ...this.model })
                .then(response => {
                    this.student_scoring_entry = response.data.map(el => ({
                        scoring_cycle_id: el.scoring_cycle_id,
                        scoring_cycle_name: el.scoring_cycle_name,
                        cycle_value: el.cycle_value,
                        cycle_value_text: el.cycle_value_text
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        exportExcel() {
            this.exporting = true
            this.errors = new Errors()
            this.$store
            this.reExamExportExcel(this.model)
                .then(response => {
                    let filename = trim(
                        response.headers['content-disposition']
                            .substring(
                                response.headers['content-disposition'].indexOf('filename')
                            )
                            .replace('filename=', ''),
                        '"'
                    )
                    FileDownload(response.data, filename)
                })
                .catch(err => {
                    let error = JSON.parse(
                        String.fromCharCode.apply(null, new Uint8Array(err))
                    )
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => (this.exporting = false))
        }
    }

}
</script>